import CompositionApi, { ref } from "@vue/composition-api";
import Vue from "vue";
import { Document } from "@/tools/msa/models";
Vue.use(CompositionApi);

const document = ref<Document | null>(null);

export default document;
